<!--
 * @Description: 网络课程学习任务 修改
 * @Author: PF
 * @Date: 2025-10-29 15:50:22
 * @LastEditors: PF
 * @LastEditTime: 2025-12-02 16:06:00
-->
<template>
  <div>
    <el-dialog class="w500 h500" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="110px">
        <el-form-item label="学期" prop="xqid">
          <el-tag v-if="ruleForm.xqmc">{{ ruleForm.xqmc }}</el-tag>
        </el-form-item>
        <el-form-item label="课程计划" prop="wljxjhid">
          <el-tag v-if="ruleForm.kcmc">{{ ruleForm.kcmc }}</el-tag>
        </el-form-item>
        <el-form-item label="学习班级">
          <el-tag v-for="item in ruleForm.bjList" :key="item" style="margin: 5px 10px 5px 0;">{{ item.bjmc }}</el-tag>
        </el-form-item>
        <el-form-item label="网络课程" prop="wlkcid">
          <el-tag v-if="ruleForm.wlkcmc">{{ ruleForm.wlkcmc }}</el-tag>
        </el-form-item>
        <el-form-item label="测试试卷">
          <el-tag v-for="(item, index) in csData" :key="item" style="margin: 5px 10px 5px 0;">{{ item.sjmc }}</el-tag>
        </el-form-item>
        <el-form-item label="考试试卷">
          <el-tag v-if="kaoShiData.sjmc">{{ kaoShiData.sjmc }}</el-tag>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import {
  loadData,
  submitEditForm,
  closeWindow,
  loadSelect
} from '@/api/common.js'
const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})

const kaoShiData = ref([])
const csData = ref([])
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/wangluojiaoxue/renwu/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          res.data.shijuanVOList.forEach(element => {
            // 试卷类型:1-考试 2-测试
            switch (element.sjlx) {
              case 1:
                kaoShiData.value = {id: element.sjid, sjmc: element.sjmc}
                break;
              case 2:
                csData.value.push({id: element.sjid, sjmc: element.sjmc})
                break;
            }
          });
        }
      })
    }
  },
  { deep: true, immediate: true }
)

</script>

<style scoped lang="less">
.container {
  display: flex;
  .zuo {
    width: 440px;
  }

  .zhong {
    background-color: #DCDFE6;
    margin: 0 30px;
    width: 1px;
  }

  .you {
    width: 478px;
    line-height: 25px;
    .you-tit {
      font-size: 16px;
      font-weight:700;
      color: #606266;
    }
    .you-fu-tit {
      font-size: 14px;
      font-weight:700;
      margin: 8px 0 8px 20px;
      color: #606266;
    }
    :deep(.el-radio-group) {
      height: auto;
    }
  }
}
</style>
